import React, {
  ReactNode,
} from 'react';
import Accordion from 'core/components/Accordion';
import isNil from 'lodash/isNil';
import ToolTip from 'core/components/Tooltip';
import Button from 'pages/Dashboard/components/Button';
import AddIcon from '@mui/icons-material/Add';

type SectionHeaderProps = {
  title?: string;
  onAdd?: () => void;
  onAddTooltip?: string;
};

type Props = {
  header?: ReactNode | string;
  headerProps?: SectionHeaderProps;
  children?: ReactNode;
};

function SectionHeader({ title, onAdd, onAddTooltip }: SectionHeaderProps) {
  return (
    <div className="flex w-full gap-2 items-center justify-between mr-2">
      <span>{title}</span>
      {!isNil(onAdd) && (
        <ToolTip title={onAddTooltip}>
          <Button
            variant="outlined"
            color="primary"
            type="button"
            className="!py-0.5 !px-3 !rounded !border-blue-500 !border"
            startIcon={<AddIcon className="!w-4 !h-4 !text-inherit" />}
            onClick={(e) => {
              e.stopPropagation();
              onAdd();
            }}
          >
            Add
          </Button>
        </ToolTip>
      )}
    </div>
  );
}

export default function Section({ header, headerProps, children }: Props) {
  const title = typeof header === 'string' ? (<h2>{header}</h2>) : header;

  return (
    <Accordion
      defaultExpanded
      header={!isNil(headerProps)
        ? (<SectionHeader {...headerProps} />)
        : title}
      disableGutters
      headerClasses={{
        root: '!px-3 !py-1 !min-h-[initial] !bg-gray-100 !text-gray-600 !font-semibold text-sm',
        content: '!m-0',
      }}
      detailsClasses={{ root: '!p-0 populate-form flex flex-col w-full' }}
    >
      {children ?? ''}
    </Accordion>
  );
}
